<!--
 * @Author: your name
 * @Date: 2020-09-22 15:07:39
 * @LastEditTime: 2023-03-11 17:18:42
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\common\clear.vue
-->
<template>
  <div @click="clearAll" class="btn">点我清除缓存</div>
</template>

<style lang="less" scoped>
.btn {
  width: 100px;
  height: 100px;
  background: red;
  color: #fff;
  text-align: center;
  line-height: 100px;
  margin: 10px auto;
  border-radius: 50%;
  font-size: 14px;
}
</style>


<script>
import { setCookie } from "@/assets/js/common.js";

export default {
  name: "clear",
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    setCookie,
    clearAll() {
      localStorage.clear();
      sessionStorage.clear();
      var date = new Date();
      date.setSeconds(date.getSeconds() + 3);
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; )
          // document.cookie=keys[i]+"=; expire="+date1+"; path=/";
          this.setCookie(keys[i], null, 0);
      }
      alert("清除缓存成功");
      setTimeout('WeixinJSBridge.call("closeWindow")', 50);
    },
  },
};
</script>